import { ActivityFeed } from "@/components/ActivityFeed/ActivityFeed";
import { useHeaderContext } from "@/hooks/useHeaderContext";
import { useEffect } from "react";
import { ActivityFeedHeader } from "@/components/Page/Header/ActivityFeedHeader";
import { useParams } from "react-router-dom";

export const ActivityFeedPage = () => {
  const { shopId } = useParams();
  const { setHeaderContent } = useHeaderContext();

  useEffect(() => {
    setHeaderContent(shopId ? <ActivityFeedHeader shopId={shopId} /> : null);
    return () => setHeaderContent(null);
  }, [setHeaderContent, shopId]);

  return (
    <div className="mx-auto mb-20 flex h-full w-full flex-col items-center p-5 text-justify">
      <h1 className="text-3xl font-bold">Activity Feed</h1>
      <div className="w-full max-w-screen-md">
        <ActivityFeed />
      </div>
    </div>
  );
};
